import React, { useState, useEffect } from 'react'
import './JourneySteps.css'
import { LuStethoscope, LuSearch, LuShoppingCart, LuChevronDown } from 'react-icons/lu'

const STORAGE_KEY = 'journey-steps-collapsed'

const steps = [
  {
    number: 1,
    icon: LuStethoscope,
    label: 'Clínica & Tratamento',
    description: 'Consulte-se com um médico ou clínica de reprodução humana e defina o seu tipo de tratamento, antes de escolher o doador.',
  },
  {
    number: 2,
    icon: LuSearch,
    label: 'Cadastre-se & Explore',
    description: 'Cadastre-se gratuitamente para explorar o perfil completo dos nossos doadores nacionais e importados à pronta entrega',
  },
  {
    number: 3,
    icon: LuShoppingCart,
    label: 'Solicite sua Reserva',
    description: 'Adicione seus doadores favoritos ao carrinho, solicite sua pré-reserva e siga o passo a passo',
  },
]

const JourneySteps: React.FC = () => {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false
    return window.localStorage.getItem(STORAGE_KEY) === '1'
  })

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0')
  }, [collapsed])

  const toggle = () => setCollapsed((c) => !c)

  return (
    <section className={`journey-steps-section ${collapsed ? 'is-collapsed' : ''}`}>
      <div className="journey-mesh" aria-hidden="true" />
      <div className="container journey-container">
        <div className="journey-header-row">
          <div className="journey-eyebrow">
            <span className="journey-eyebrow-line" />
            <span className="journey-eyebrow-text">Como começar</span>
            <span className="journey-eyebrow-line" />
          </div>
          <button
            type="button"
            className="journey-toggle"
            onClick={toggle}
            aria-expanded={!collapsed}
            aria-controls="journey-content"
            title={collapsed ? 'Expandir passo a passo' : 'Minimizar passo a passo'}
          >
            <span className="journey-toggle-text">
              {collapsed ? 'Expandir' : 'Minimizar'}
            </span>
            <LuChevronDown
              size={16}
              className={`journey-toggle-icon ${!collapsed ? 'is-flipped' : ''}`}
              strokeWidth={2}
            />
          </button>
        </div>

        <h2 className="journey-steps-title">
          Primeiros passos para aquisição da <em>amostra seminal</em>
        </h2>

        <div id="journey-content" className="journey-content" aria-hidden={collapsed}>
          <div className="journey-grid">
            <svg
              className="journey-connector-svg"
              viewBox="0 0 1000 60"
              preserveAspectRatio="none"
              aria-hidden="true"
            >
              <path
                d="M 80 30 Q 333 -10 500 30 T 920 30"
                fill="none"
                stroke="url(#journeyStroke)"
                strokeWidth="1.5"
                strokeDasharray="6 8"
              />
              <defs>
                <linearGradient id="journeyStroke" x1="0" x2="1" y1="0" y2="0">
                  <stop offset="0%" stopColor="#1CA7B6" stopOpacity="0.15" />
                  <stop offset="50%" stopColor="#1CA7B6" stopOpacity="0.8" />
                  <stop offset="100%" stopColor="#FA5A84" stopOpacity="0.5" />
                </linearGradient>
              </defs>
            </svg>

            {steps.map(({ number, icon: Icon, label, description }, index) => (
              <article
                key={number}
                className={`journey-step journey-step--${index}`}
                style={{ animationDelay: `${index * 140}ms` }}
              >
                <div className="journey-step-numeral" aria-hidden="true">
                  {String(number).padStart(2, '0')}
                </div>
                <div className="journey-step-body">
                  <div className="journey-step-icon-pill">
                    <Icon size={18} strokeWidth={1.75} />
                  </div>
                  <h3 className="journey-step-label">{label}</h3>
                  <p className="journey-step-description">{description}</p>
                </div>
                <span className="journey-step-marker" aria-hidden="true" />
              </article>
            ))}
          </div>
        </div>

        <button
          type="button"
          className="journey-summary"
          onClick={toggle}
          aria-hidden={!collapsed}
          tabIndex={collapsed ? 0 : -1}
        >
          {steps.map(({ number, icon: Icon, label }, index) => (
            <React.Fragment key={number}>
              {index > 0 && <span className="journey-summary-sep" aria-hidden="true">›</span>}
              <span className="journey-summary-item">
                <span className="journey-summary-num">{String(number).padStart(2, '0')}</span>
                <Icon size={14} strokeWidth={1.75} />
                <span className="journey-summary-label">{label}</span>
              </span>
            </React.Fragment>
          ))}
        </button>
      </div>
    </section>
  )
}

export default JourneySteps
